import axiosInstance from '../../utils/axiosInstance';
import CustomerResponse, {
  CreateCustomerRequest,
  UnpaidCustomerResponse,
  PaidCustomerResponse, // Import the new interface
} from '../../model/Customer.model';

class CustomerService {
  private readonly baseURL = '/customer';
  async getCustomerList(): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(this.baseURL);
    return data;
  }

  async createCustomer(
    customer: CreateCustomerRequest
  ): Promise<CustomerResponse> {
    const { data } = await axiosInstance.post(
      `${this.baseURL}/create`,
      customer
    );
    return data;
  }

  async editCustomer(
    id: number,
    customer: CreateCustomerRequest
  ): Promise<CustomerResponse> {
    const { data } = await axiosInstance.put(
      `${this.baseURL}/edit/${id}`,
      customer
    );
    return data;
  }

  async deleteCustomer(id: number): Promise<void> {
    await axiosInstance.delete(`${this.baseURL}/delete/${id}`);
  }

  async getCustomerById(id: number): Promise<CustomerResponse> {
    const { data } = await axiosInstance.get(`${this.baseURL}/${id}`);
    return data;
  }

  async getCustomerIsNotBeenAssignment(
    eId: number
  ): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(`${this.baseURL}/unsigned/${eId}`);
    return data;
  }

  async searchCustomerByName(name: string): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(`${this.baseURL}/search`, {
      params: { name },
    });
    return data;
  }

  async getCustomersAssignedToEmployeeWithRoleEmployee(
    userId: number
  ): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(
      `${this.baseURL}/assigned-to-role-employee/${userId}`
    );
    return data;
  }

  async getUnpaidCustomers(
    month: number,
    year: number
  ): Promise<UnpaidCustomerResponse> {
    const { data } = await axiosInstance.get(
      `${this.baseURL}/unpaid-customers`,
      {
        params: { month, year },
      }
    );
    return data;
  }

  async getPaidCustomers(
    month: number,
    year: number
  ): Promise<PaidCustomerResponse> {
    const { data } = await axiosInstance.get(`${this.baseURL}/paid-customers`, {
      params: { month, year },
    });
    return data;
  }

  // New partner-related methods
  async getCustomersByPartnerId(
    partnerId: number
  ): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(
      `${this.baseURL}/by-partner/${partnerId}`
    );
    return data;
  }

  async getCustomersWithoutPartner(): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(`${this.baseURL}/without-partner`);
    return data;
  }

  async getNewCustomers(
    month: number,
    year: number
  ): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(`${this.baseURL}/new-customers`, {
      params: { month, year },
    });
    return data;
  }

  async getNewCustomersInCurrentMonth(): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(
      `${this.baseURL}/new-customers/current-month`
    );
    return data;
  }

  async getCustomersWithDebt(): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(`${this.baseURL}/with-debt`);
    return data;
  }

  async getCustomersWithLongTermDebt(): Promise<CustomerResponse[]> {
    const { data } = await axiosInstance.get(
      `${this.baseURL}/with-long-term-debt`
    );
    return data;
  }
}

export default new CustomerService();
